import { Controller } from "@hotwired/stimulus"

// Handles drag/drop, upload routing, and "plus tile" triggers inside the modal.
export default class extends Controller {
  static targets = ["dropzone","imagesInput","filesInput","avatarInput","imagesPlus","filesPlus"]

  // ----- Drag & drop -----
  dragover(e) {
    e.preventDefault()
    this._setHover(true)
  }
  dragenter(e) {
    e.preventDefault()
    this._setHover(true)
  }
  dragleave(e) {
    // Ignore child-to-parent leave events by checking currentTarget
    if (e.currentTarget.contains(e.relatedTarget)) return
    e.preventDefault()
    this._setHover(false)
  }
  drop(e) {
    e.preventDefault()
    this._setHover(false)

    const files = [...e.dataTransfer.files]
    if (!files.length) return

    const images = files.filter(f => f.type?.startsWith("image/"))
    const nonImages = files.filter(f => !f.type?.startsWith("image/"))

    if (images.length && this.hasImagesInputTarget) {
      this._assignAndSubmit(this.imagesInputTarget, images)
    }
    if (nonImages.length && this.hasFilesInputTarget) {
      this._assignAndSubmit(this.filesInputTarget, nonImages)
    }
  }

  // ----- “Plus” tiles -----
  triggerImages() {
    if (this.hasImagesInputTarget) this.imagesInputTarget.click()
  }
  triggerFiles() {
    if (this.hasFilesInputTarget) this.filesInputTarget.click()
  }
   triggerAvatar() { if (this.hasAvatarInputTarget) this.avatarInputTarget.click() }

  avatarChanged(e) {
    const input = e.target
    const form = input.form
    if (!form) return
    if (input.files && input.files.length > 0) {
      // Prefer requestSubmit (fires submit events so Turbo can intercept)
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit()
      } else {
        // Fallback: click hidden submit (still fires submit events)
        const btn = form.querySelector("[data-avatar-submit]") || form.querySelector("[type=submit]")
        if (btn) btn.click()
        else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }))
      }
    }
  }
  
  imagesChanged(e) {
    const form = e.target.form
    if (e.target.files?.length && form) this._submit(form)
  }
  filesChanged(e) {
    const form = e.target.form
    if (e.target.files?.length && form) this._submit(form)
  }

  // ----- Helpers -----
  _assignAndSubmit(input, files) {
    const dt = new DataTransfer()
    files.forEach(f => dt.items.add(f))
    input.files = dt.files
    if (input.form) this._submit(input.form)
  }

  _submit(form) {
    if (typeof form.requestSubmit === "function") form.requestSubmit()
    else {
      const btn = form.querySelector("[type=submit]") || form.appendChild(Object.assign(document.createElement("button"), { type: "submit", hidden: true }))
      btn.click()
    }
  }

  _setHover(on) {
    if (!this.hasDropzoneTarget) return
    this.dropzoneTarget.classList.toggle("ring-emerald-500", on)
    this.dropzoneTarget.classList.toggle("border-emerald-500", on)
    this.dropzoneTarget.classList.toggle("bg-emerald-50/40", on)
    this.dropzoneTarget.classList.toggle("text-emerald-900", on)
  }
}
